import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services';
import { CurrentCareerService } from '../services/current-career.service';

@Injectable()
export class CareerInterceptor implements HttpInterceptor {
	constructor(
		private _careerService: CurrentCareerService
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const careerId = this._careerService.currentCareerId.value || this._careerService.getCareerFromStorage();

		// Un header già impostato esplicitamente (e non vuoto) dal service vince sul valore corrente
		if (careerId && !request.headers.get('X-Career')) {
			request = request.clone({
				setHeaders: {
					'X-Career': careerId,
				},
			});
		}

		return next.handle(request);
	}
}
